import networkService from '../Network/NetworkManager';
import APPURL from '../Constants/URLConstants';

export const tradlyCopilot = async ({prompt, systemPrompt}) => {
  const responseJson = await networkService.networkCall(
    APPURL.URLPaths.copilot,
    'post',
    JSON.stringify({
      prompt,
      system_instructions: systemPrompt,
    }),
  );

  return responseJson;
};
